/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-09-14 10:53:25
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2024-10-25 15:33:15
 * @FilePath: \game2\src\views\fzg\index.js
 */
import Vue from "vue";
import Tpl from "./template.vue";
import Toast from "../../components/toast";
import Base from "../../utils/base";
import Report from "../../utils/report";
import generalMethod from "../../utils/generalMethod";
import SyModel from "../../models/sy";
import Storage from "../../utils/storage";
import Ciphertext from "../../utils/Ciphertext";
import "../../utils/initFaceBookSdk";

import "../../assets/style/main.scss";
import "../../registerServiceWorker";
import { setTheme } from "../../utils/selectTheme";

setTheme();

Vue.prototype.$Toast = Toast;
Vue.prototype.$Base = Base;
Vue.prototype.$Report = Report;
Vue.prototype.$generalMethod = generalMethod;
Vue.prototype.$Storage = Storage;
Vue.prototype.$Ciphertext = Ciphertext;
Vue.prototype.$SyModel = SyModel;
Vue.use(Toast);
Vue.use(Base);
Vue.use(Report);
Vue.use(generalMethod);
Vue.use(Storage);
Vue.use(Ciphertext);
Vue.use(SyModel);
new Vue({
  render: (h) => h(Tpl),
}).$mount("#rastar");
